import { render, staticRenderFns } from "./view-intermediary.vue?vue&type=template&id=0cd15957"
import script from "./view-intermediary.vue?vue&type=script&lang=js"
export * from "./view-intermediary.vue?vue&type=script&lang=js"
import style0 from "./view-intermediary.vue?vue&type=style&index=0&id=0cd15957&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports